// extracted by mini-css-extract-plugin
module.exports = {"floatingBtnContainer":"CreateEventButton_floatingBtnContainer__1WKa4","addIcon":"CreateEventButton_addIcon__2YTb-"};